'use client'
import { Button } from '../buttons/button';

import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import ProWelcomeImage from '@/assets/pro-welcome-image.svg';
import MainCheck from '@/assets/icons/main-check.svg';
import { getUserSubscription } from '@/services/user';
import { Subscription } from '@/app/types/Subscription';
import { LoadingSpinner } from './spinner';

export const WelcomeDialog: React.FC = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [subscription, setSubscription] = useState<Subscription | null>(null);

    useEffect(() => {
        const fetchSubscriptionData = async () => {
            const updatedSubscription = await getUserSubscription();
            setSubscription(updatedSubscription);
        };
        fetchSubscriptionData();
    }, []);

    return (
        <Dialog open={isOpen} onOpenChange={() => setIsOpen(false)}>
            <DialogContent className="flex bg-[#FBFBF9] z-modal rounded-xl justify-center w-full items-center px-[74px] pb-[40px]">
                <DialogHeader className="w-full flex flex-col items-center">
                    <DialogTitle>
                        <div className="flex flex-col w-full text-center gap-2 items-center text-2xl">
                            <ProWelcomeImage />
                            Welcome to Pro Plan!
                        </div>
                    </DialogTitle>
                    <DialogDescription>
                        <div className="flex flex-col w-full text-center gap-2">
                        </div>
                    </DialogDescription>
                    <div className="flex flex-col w-full text-center gap-2 text-base">
                        <p>
                            Now get ready to enjoy every month with Pro:
                        </p>
                    </div>
                    <div className="flex flex-col w-full text-sm gap-3 pt-8">
                        <div className="flex flex-row gap-3 items-center leading-tight">
                            <MainCheck />
                            <div className="flex flex-row gap-2 items-center">{subscription ? subscription.credits : <LoadingSpinner />} credits/month for company reports</div>
                        </div>
                        <div className="flex flex-row gap-3 items-center leading-tight">
                            <MainCheck />
                            <p>Access to Deal Score analysis</p>
                        </div>
                        <div className="flex flex-row gap-3 items-center leading-tight">
                            <MainCheck />
                            <p>Priority access to new features and updates</p>
                        </div>
                        <div className="flex flex-row gap-3 items-center leading-tight">
                            <MainCheck />
                            <p>Bonus: +25 additional credits</p>
                        </div>
                    </div>
                    <DialogFooter>
                        <div className="flex flex-col gap-[21px] pt-10">
                            <div className="flex flex-col w-full text-center gap-2">
                                <Button variant='default' onClick={() => { setIsOpen(false) }} className="bg-light-green/01 text-black bg-light-green/01 hover:bg-light-green/01 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1.00)] transition-shadow duration-200">Let's go!</Button>
                            </div>
                            <div className="flex flex-col w-full text-center gap-2 text-xs opacity-75">
                                <p>An email with your order details is on its way to you.</p>
                            </div>
                        </div>
                    </DialogFooter>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    );
}; 